export const socketServerURL = 'https://hookah.work:5001';

let crm_name;
if (process.env.NODE_ENV==='development') {
	crm_name = 'demo';
} else {
	crm_name = window.location.host.split('.').shift();
}

export const crm = crm_name;
export const socketRoom = 'hw.'+crm_name;



// WEBPACK FOOTER //
// ./src/config/index.js